export default __webpack_public_path__ + "static/media/ysd-008-setu4.68a96c62.jpg";